exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wow_bg-trans[data-v-a7d14332] {\n  background: rgba(255, 255, 255, 0.9);\n}\n.hero-gradient[data-v-a7d14332]::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1;\n  height: 100%;\n  background: rgb(1, 23, 47);\n  opacity: 0.7;\n}\n.ww-sep[data-v-a7d14332] {\n  width: 100px;\n  height: 4px;\n  background: #ffb402;\n  margin: 10px 0;\n}\n.ww-sep.small[data-v-a7d14332] {\n  width: 30px;\n}\n", ""]);

// exports
